import * as React from 'react';

interface IProps {
    readonly label: string | React.ReactElement;
    readonly children: React.ReactNode;
    readonly className?: string;
    readonly onClick?: (e: HTMLButtonElement | null) => void;
}

const AccordionItem = ({ children }: IProps) => {
    return <>{children}</>;
};

export default AccordionItem;
